import { Button } from 'edrolo-style-guide';
import styles from './WorkedChecklistQuestion.scss';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import questionTypePropInterface from '../../questionTypePropInterface';

const WorkedChecklistQuestion = ({
  question,
  onSubmit,
  onSubmitTeacherAnswer,
}) => (
  <div data-test={`question-${EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE}`}>
    <p className={styles.paperPrompt}>
      Please complete this question with pen and paper
    </p>
    <Button
      onClick={() =>
        onSubmitTeacherAnswer
          ? onSubmitTeacherAnswer()
          : onSubmit({ submittedText: '' })
      }
      data-test={`submit-${EXAM_QUESTION_TYPES.WORKED_ANNOTATED_IMAGE}`}
    >
      {onSubmitTeacherAnswer ? 'View answer' : 'Iʼm ready to see the solution'}
    </Button>
  </div>
);

WorkedChecklistQuestion.propTypes = {
  ...questionTypePropInterface,
};

export default WorkedChecklistQuestion;
